import moment from "moment";

export default class ODataService {

    load(loadFunction: Function, loadOptions: any, responseFunction: Function) {
        //Clonamos el objeto, ya que si no lo hacemos la grid se pone a cargar datos indefinidamente
        let clonedLoadOptions = this.clone(loadOptions);

        const params = this.processLoadOptions(clonedLoadOptions);

        return loadFunction(params).then((res: any) => {
            return responseFunction(res);
        });
    }

    loadHeader(loadFunction: Function, loadOptions: any, dataField: string, responseFunction: Function) {

        //Clonamos el objeto, ya que si no lo hacemos la grid se pone a cargar datos indefinidamente
        let clonedLoadOptions = this.clone(loadOptions);
        let params = this.processLoadOptions(clonedLoadOptions);
        params += "&$distinct=true&$select=" + dataField;

        if(loadOptions.searchValue){
            params+="&$selectContains="+loadOptions.searchValue;
        }

        return loadFunction(params).then((res: any) => {
            return responseFunction(res);
        });
    }

    // Procesa la opciones de carga y devuelve un queryString para OData
    private processLoadOptions(loadOptions: any) {
        var params = "?";
        // Se obtiene el tamaño de página y que página se quiere consultar
        loadOptions.skip === undefined
            ? (params += "$skip=" + 0)
            : (params += "$skip=" + loadOptions.skip);
        loadOptions.take === undefined
            ? (params += "&$top=" + 5)
            : (params += "&$top=" + loadOptions.take);

        if (loadOptions.requireTotalCount === true) {
            params += "&$count=true";
        }

        // Se comprueba si hay filtros y se procesan
        if (loadOptions.filter) {
            var index = 0;
            var stringFilter = "&$filter=";
            var item;
            // Comprobamos si se aplica un filtro o más
            if (typeof loadOptions.filter[0] === "object") {
                //Array de filtros
                while (loadOptions.filter[index]) {
                    item = loadOptions.filter[index];
                    if (typeof item === "object") {
                        stringFilter += this.switchTypeFilter(item);
                    } else {
                        stringFilter += " " + item + " ";
                    }
                    index++;
                }
            } else {
                // Solo un filtro
                stringFilter += this.switchTypeFilter(loadOptions.filter);
            }
            params += stringFilter;
        }

        // Se comprueba si hay filtros y se procesan
        if (loadOptions.group) {
          var index = 0;
          var stringFilter = "&$orderby=";
          var group;
            //Array de selectores
            while (loadOptions.group[index]) {
              group = loadOptions.group[index];
              stringFilter += "" + group.selector + "";
              index++;
            }
          params += stringFilter;
        }

        // Se comprueba si hay ordenación
        if (loadOptions.sort) {
            params += "&$orderby=" + loadOptions.sort[0].selector.replace(".", "/");
            if (loadOptions.sort[0].desc) {
                params += " desc";
            }
        }
        return params;
    }

    // Sustituye los operadores de comparación y filtros para que se adapten a OData
    private switchTypeFilter(item: any) {
        var response = "";

        // Sustituimos los puntos por barras para poder hacer filtros sobre entidades relacionadas
        item[0] = item[0].replace(".", "/");

        // Comprobamos si es de tipo fecha
        if (item.length == 3 && item[2].length == 19 && moment(item[2]).isValid()) {
            item[2] = new Date(item[2]).toJSON();
        }

        switch (item[1]) {
            case "=":
                if (typeof item[2] === "string") {
                    response += `${item[0]} eq '${item[2]}'`;
                } else {
                    response += `${item[0]} eq ${item[2]}`;
                }
                break;
            case "<>":
                if (typeof item[2] === "string") {
                    response += `${item[0]} ne '${item[2]}'`;
                } else {
                    response += `${item[0]} ne ${item[2]}`;
                }
                break;
            case "<":
                response += `${item[0]} lt ${item[2]}`;
                break;
            case ">":
                response += `${item[0]} gt ${item[2]}`;
                break;
            case "<=":
                response += `${item[0]} le ${item[2]}`;
                break;
            case ">=":
                response += `${item[0]} ge ${item[2]}`;
                break;
            case "contains":
                response += `contains(${item[0]}, '${item[2]}')`;
                break;
            case "notcontains":
                response += `contains(${item[0]}, '${item[2]}') eq false`;
                break;
            case "startswith":
                response += `startswith(${item[0]}, '${item[2]}')`;
                break;
            case "endswith":
                response += `endswith(${item[0]}, '${item[2]}')`;
                break;

            default:
                break;
        }

        return response;
    }

    private clone(obj: any): any {
        var copy;

        // Handle the 3 simple types, and null or undefined
        if (null == obj || "object" != typeof obj) return obj;

        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }

        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (var i = 0, len = obj.length; i < len; i++) {
                copy[i] = this.clone(obj[i]);
            }
            return copy;
        }

        // Handle Object
        if (obj instanceof Object) {
            copy = <any>{};
            for (var attr in obj) {
                if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
            }
            return copy;
        }

        throw new Error("Unable to copy obj! Its type isn't supported.");
    }
}

// export const odataService = new ODataService();